<template>
    <div class="leads-listings">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <p class="text-muted">Profile</p>
                    <h2 class="listing-title d-inline-block mb-0">Leads</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <base-button v-show="backButton" type="primary" icon size="sm" @click="close()">
                        <span class="btn-inner--text">Back / Close</span>
                    </base-button>
                    <b-button variant="warning" class="btn-header" @click="toggleReassignHistoryDrawer()"
                        v-if="_gHlp.checkAccess(['role_admin', 'role_corporate', 'role_super_admin', 'role_it_admin']) && _gAuth.activeCorpIsUseLeadAutoAssignment()">Reassign
                        Lead</b-button>
                    <b-button variant="primary" class="btn-header" @click="toggleCreateModal()"
                        v-if="_gHlp.checkAccess(['l_lead__create'])">Create Lead</b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
          <LeadsListingTable :mainStatusList="mainStatusList" :subStatusList="subStatusList" />
        </b-container>

        <!-- Create New Modal -->
        <modal :show.sync="modals.create_new" modalClasses="medium-sized-modal">
            <h6 slot="header" class="modal-title">Create Leads</h6>
            <b-form @submit.prevent="submit">
                <b-row>
                    <b-col cols="12">
                        <b-form-group>
                            <label>Name <span class="text-danger">*</span></label>
                            <b-form-input v-model="form.name" required></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group>
                            <label>Contact Number</label>
                            <div class="d-flex justify-content-between">
                                <b-form-input v-model="form.country_code" class="col-md-4 mr-1">
                                </b-form-input>
                                <b-form-input class="col-md-8" type="text" @keydown="_gHlp.checkNonNumericInput" v-model="form.contact_no" maxlength="17"></b-form-input>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group label="Email Address">
                            <b-form-input type="email" v-model="form.email"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group label="Income" v-if="_gAuth.isAppSas() || _gHlp.checkAccess(['stg_channel_platform'])">
                            <CurrencyInput v-model="form.income"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" v-if="_gAuth.isAppSas() || _gHlp.checkAccess(['stg_channel_platform'])">
                        <b-form-group label="Type">
                            <el-select v-model="form.type" placeholder="Select Type">
                                <el-option label="Personal" value="Personal" />
                                <el-option label="Company" value="Company" />
                            </el-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6"
                        v-if="form.type === 'Company' && (_gAuth.isAppSas() || _gHlp.checkAccess(['stg_channel_platform']))">
                        <b-form-group label="Platform">
                            <el-select v-model="form.platform_id" placeholder="Select Platform">
                                <el-option v-for="item in list_platforms" :key="item.platform_id" :label="item.name"
                                    :value="item.platform_id">
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6"
                        v-if="form.type === 'Company' && (_gAuth.isAppSas() || _gHlp.checkAccess(['stg_channel_platform']))">
                        <b-form-group label="Channel">
                            <el-select v-model="form.channel_id" placeholder="Select Channel">
                                <el-option v-for="item in list_channels" :key="item.channel_id" :label="item.name" :value="item.channel_id">
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    <!-- <b-col>
                        <b-form-group cols="12" md="6">
                            <el-date-picker v-model="form.appointment_at" type="datetime" format="yyyy-MM-dd hh:mm:ss"
                                value-format="yyyy-MM-dd hh:mm:ss" placeholder="Select appointment time and date">
                            </el-date-picker>
                        </b-form-group>
                    </b-col> -->
                    </b-row>
                    <b-row>
                    <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button variant="primary" type="submit" class="w-100" :disabled="is_loading_submit">Create</b-button>
                    </b-col>
                </b-row>
            </b-form>
            <div slot="footer"></div>
        </modal>
        <ReassignHistoryDrawer ref="reassign_history_drawer" :mainStatusList="mainStatusList" :subStatusList="subStatusList" />
    </div>
</template>
<script>
import ReassignHistoryDrawer from '@/views/Leads/Drawers/ReassignHistoryDrawer'
import { Dropdown, DropdownItem, DatePicker, DropdownMenu, Select, Option } from 'element-ui'
import LeadsListingTable from '@/views/Leads/LeadsListingTableCount.vue'
import {
    helperFunctionMixin,
    notifyFunctionMixin,
    axios,
    services,
    getHeader
} from '@/assets/js/httpImports.js'
import '@/assets/js/formValidations.js'
import CurrencyInput from '@/components/CurrencyInput'
import { useAuthStore } from '@/stores/authStore'
import { mapState, mapActions } from 'pinia'
import { useConfigStore } from '@/stores/configStore';
import { useLookupStore } from '@/stores/lookupStore';
import _ from 'lodash'

export default {
    components: {
        LeadsListingTable,
				CurrencyInput,
        ReassignHistoryDrawer,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
    },
    data() {
        return {
            backButton: false,
            modals: {
                create_new: false
            },
            form: {
                name: '',
                contact_no: '',
                email: '',
                income: 0,
                platform_id: '',
                channel_id: '',
                type: 'Personal',
                country_code: '+60',
                appointment_at:''
            },
            is_loading_submit: false,
            mainStatusList: [],
            subStatusList: [],
            loadingStates: {
                statuses: false,
                initialization: false
            }
        };
    },
    async created() {
        try {
            this.loadingStates.initialization = true

            await this.loadCriticalData()
            
            if (this.$route.params.token) {
                this.backButton = true;
            }
            
            this.form.channel_id = this.auth_user.account_info.channel_id;
            this.form.platform_id = this.auth_user.account_info.platform_id;
        } catch (error) {
            console.error('Failed to initialize leads listing:', error)
        } finally {
            this.loadingStates.initialization = false
        }
    },
    mounted() {
      //this.initPage();
    },
    computed: {
        ...mapState(useAuthStore, ['auth_user']),
        ...mapState(useConfigStore, ['app_code']),
        ...mapState(useLookupStore, ['list_platforms','list_channels','list_lead_statuses'])
    },
    methods: {
		...mapActions(useLookupStore, ['getLeadStatuses']),

        async loadCriticalData() {
            setTimeout(() => {
                this.initPage().catch(error => {
                    console.warn('Failed to load lead statuses:', error)
                })
            }, 100)
        },
        
        async initPage() {
            try {
                this.loadingStates.statuses = true
                
                if (_gHlp.isEmpty(this.list_lead_statuses)) {
                    const resp = await this.getLeadStatuses()
                    let listStatus = _gHlp.getValue(resp, 'data', []);
                    listStatus.filter((element) => element.group == "main" ? this.mainStatusList.push(element) : this.subStatusList.push(element))
                    this.subStatusList = _gHlp.sortByAttribute(this.subStatusList, 'parent_status', 'asc')
                } else {
                    this.list_lead_statuses.filter((element) => element.group == "main" ? this.mainStatusList.push(element) : this.subStatusList.push(element))
                    this.subStatusList = _gHlp.sortByAttribute(this.subStatusList, 'parent_status', 'asc')
                }
            } catch (error) {
                console.error('Failed to initialize page data:', error)
                throw error
            } finally {
                this.loadingStates.statuses = false
            }
        },
		submit() {
            this.is_loading_submit = true
            let url = _gAuth.isAppSas() ? 'leads' : 'vps/leads'
            let formData = _gHlp.generateFormData(this.form)
            axios.post(services.lead + url, formData, { headers: getHeader() })
                .then(res => {
                    // _gHlp.resetFormToNull(this.form)
                    _gHlp.resetFormAttributes(this.form)
                    _gNotif.notifySuccess('<b>Lead : ' + res.data.data.name + '</b> - Successfully Created.')
                    this.is_loading_submit = false
                    this.$router.push('leadProfileDetails/' + res.data.data.lead_id)
                })
                .catch(e => {
                    this.is_loading_submit = false
										_gNotif.errorFunction(e)
                    console.error(e)
                })
        },
        close() {
            if (this.$route.params.token) {
                // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
                window.history.back();
                window.close();
            }
            else {
                this.$router.back();
            }
        },
        toggleCreateModal() {
            this.modals.create_new = !this.modals.create_new
        },
        toggleReassignHistoryDrawer() {
            this.$refs.reassign_history_drawer.showDrawer();
        }
    }
}
</script>